import React from 'react';
import { UpcomingBookingsDataStructure } from 'AppClient/api/Bookings';
import { ProviderRow } from './ProviderRow';
import { Status } from 'components';

interface Props {
	bookingData: UpcomingBookingsDataStructure;
	disableTermsAndConditions: boolean;
}
export const ProviderRowInactive: React.FC<Props> = ({ bookingData }) => {
	return (
		<ProviderRow
			providerName={bookingData.servicePartnerName}
			providerDescription={bookingData.servicePartnerDescription}
			isSelected={false}
			disableTermsAndConditions
		>
			<Status status="error">Amendment not possible</Status>
		</ProviderRow>
	);
};
